import { useState, type JSX } from 'react';

import { Portada } from './brand/Portada';
import { APP, MODULOS, Shell, type ModuloId, type Vista } from './brand/Shell';
import { PanelActos } from './features/PanelActos';
import { PanelActuaciones } from './features/PanelActuaciones';
import { PanelBitacora } from './features/PanelBitacora';
import { PanelExpedientes } from './features/PanelExpedientes';
import { PanelLinea } from './features/PanelLinea';

const PANELES: Record<ModuloId, () => JSX.Element> = {
  expedientes: PanelExpedientes,
  'linea-de-tiempo-y-terminos': PanelLinea,
  'actuaciones-y-pruebas': PanelActuaciones,
  'generador-de-actos': PanelActos,
  'bitacora-de-evidencia': PanelBitacora,
};

export default function App() {
  // Se abre en la portada: quien llega ve primero de qué se compone la
  // herramienta, en vez de caer dentro del primer módulo sin contexto.
  const [vista, setVista] = useState<Vista>('portada');
  const Panel = vista === 'portada' ? null : PANELES[vista];

  return (
    <Shell vista={vista} onVista={setVista}>
      {Panel ? (
        <Panel />
      ) : (
        <Portada
          titulo={APP.nombre}
          descripcion={APP.resumen}
          modulos={MODULOS}
          onAbrir={(id) => setVista(id as ModuloId)}
        />
      )}
    </Shell>
  );
}
